var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOauth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.454 0.145081C68.5482 -1.38692 83.1978 9.42508 91.5742 22.5982C95.7742 29.2032 99.895 39.2349 99.914 49.5421C99.9343 60.7411 96.3063 70.4392 91.5742 77.5551C86.7105 84.8689 80.4198 90.9097 72.5425 94.8763C59.3748 101.507 40.9725 101.688 28.919 95.3039C15.4953 88.1943 5.17432 78.0464 1.33366 60.4479C-0.203344 53.4052 -0.380011 44.3054 1.76132 36.4979C2.26382 34.6664 3.17699 32.7389 3.89982 30.9381C7.37349 22.2841 13.286 14.7587 20.5793 9.55391C23.51 7.46258 27.0653 5.38258 30.2022 3.99408C34.1052 2.26658 40.6765 0.545581 46.454 0.145081Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3636 50.7874C88.3636 71.6688 71.4359 88.5953 50.5549 88.5953C29.6739 88.5953 12.7466 71.6688 12.7466 50.7874C12.7466 29.9066 29.6739 12.9788 50.5549 12.9788C71.4357 12.9788 88.3636 29.9066 88.3636 50.7874Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.454 0.145081C68.5482 -1.38692 83.1978 9.42508 91.5742 22.5982C95.7742 29.2032 99.895 39.2349 99.914 49.5421C99.9343 60.7411 96.3063 70.4392 91.5742 77.5551C86.7105 84.8689 80.4198 90.9097 72.5425 94.8763C59.3748 101.507 40.9725 101.688 28.919 95.3039C15.4953 88.1943 5.17432 78.0464 1.33366 60.4479C-0.203344 53.4052 -0.380011 44.3054 1.76132 36.4979C2.26382 34.6664 3.17699 32.7389 3.89982 30.9381C7.37349 22.2841 13.286 14.7587 20.5793 9.55391C23.51 7.46258 27.0653 5.38258 30.2022 3.99408C34.1052 2.26658 40.6765 0.545581 46.454 0.145081ZM38.9695 3.78041C30.763 5.90808 24.7458 9.71992 19.5102 13.8309C11.9603 19.7589 7.14732 28.0314 4.32749 37.9947C1.19032 49.0794 3.20549 62.4931 7.53516 70.9261C12.025 79.6714 18.0535 86.4599 26.5668 91.2409C34.8493 95.8923 46.4987 98.8789 58.643 96.5869C69.433 94.5506 77.6278 89.8501 84.3038 82.9011C93.2358 73.6036 100.415 56.4787 95.6375 38.4224C94.3605 33.5966 92.691 28.5669 90.0775 24.3089C88.6655 22.0086 86.5935 19.7456 84.5177 17.4661C76.6833 8.86258 64.0212 1.44875 47.737 2.49725C44.638 2.69675 41.9145 3.01675 38.9695 3.78041Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9588 96.2495L96.6485 52.5608L96.4128 52.3251L52.7231 96.0138L52.9588 96.2495Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1395 92.7895L93.0197 48.9102L92.784 48.6745L48.9038 92.5538L49.1395 92.7895Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3202 89.33L89.3912 45.2597L89.1555 45.024L45.0845 89.0943L45.3202 89.33Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5008 85.87L85.7625 41.6092L85.5268 41.3735L41.2651 85.6343L41.5008 85.87Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6815 82.4102L82.1338 37.9585L81.8981 37.7228L37.4458 82.1745L37.6815 82.4102Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8617 78.9512L78.5045 34.308L78.2688 34.0723L33.626 78.7155L33.8617 78.9512Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0423 75.4905L74.876 30.6575L74.6403 30.4218L29.8066 75.2548L30.0423 75.4905Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.223 72.0307L71.2472 27.0068L71.0115 26.7711L25.9873 71.7949L26.223 72.0307Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4032 68.5709L67.6172 23.3564L67.3815 23.1207L22.1675 68.3352L22.4032 68.5709Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5838 65.1109L63.9893 19.7059L63.7536 19.4702L18.3481 64.8752L18.5838 65.1109Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7645 61.6512L60.3607 16.0553L60.125 15.8196L14.5288 61.4155L14.7645 61.6512Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9452 58.1914L56.7322 12.4047L56.4965 12.169L10.7095 57.9557L10.9452 58.1914Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12535 54.7314L53.103 8.7542L52.8673 8.51849L6.88965 54.4957L7.12535 54.7314Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30601 51.2715L49.4743 5.10368L49.2386 4.86798L3.07031 51.0358L3.30601 51.2715Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05566 51.7132L47.6183 96.2779L47.854 96.0422L3.29137 51.4775L3.05566 51.7132Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66943 48.0477L51.3188 92.6992L51.5545 92.4635L6.90514 47.812L6.66943 48.0477Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2832 44.3822L55.0192 89.1202L55.2549 88.8845L10.5189 44.1465L10.2832 44.3822Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.897 40.7167L58.7198 85.5415L58.9555 85.3059L14.1327 40.481L13.897 40.7167Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5107 37.0512L62.4202 81.9625L62.6559 81.7268L17.7464 36.8155L17.5107 37.0512Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1245 33.3857L66.121 78.3837L66.3567 78.148L21.3602 33.15L21.1245 33.3857Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7383 29.7202L69.8214 74.8049L70.0572 74.5692L24.974 29.4845L24.7383 29.7202Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3521 26.0547L73.5221 71.2259L73.7578 70.9902L28.5878 25.819L28.3521 26.0547Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9658 22.3892L77.2227 67.647L77.4584 67.4113L32.2015 22.1535L31.9658 22.3892Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5801 18.7237L80.9234 64.0678L81.1591 63.8321L35.8158 18.488L35.5801 18.7237Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1938 15.0582L84.624 60.4894L84.8597 60.2537L39.4296 14.8225L39.1938 15.0582Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8071 11.3927L88.3241 56.9104L88.5598 56.6747L43.0428 11.157L42.8071 11.3927Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4214 7.7274L92.0251 53.3317L92.2608 53.096L46.6571 7.4917L46.4214 7.7274Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0352 4.06187L95.7255 49.7527L95.9612 49.517L50.2709 3.82617L50.0352 4.06187Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9514 17.6799C78.0192 13.7477 73.1849 10.2044 67.4102 8.05707C61.4246 5.83124 54.6536 3.95507 46.6677 4.63557C33.9467 5.71991 25.0151 11.4274 18.2269 18.1076C13.4722 22.7864 9.89572 28.5199 7.53489 35.2147C4.06855 45.0449 4.27889 56.6477 8.17639 66.6492C11.5009 75.1804 16.9422 82.0614 24.6421 87.3917C31.8806 92.4029 42.2696 96.2894 53.9381 95.3039C68.1501 94.1036 78.5487 86.8122 85.3726 78.4106C87.1186 76.2612 88.8546 73.8317 89.8631 70.9262C90.8512 68.8327 91.3349 67.4096 91.7877 66.6494C93.6831 62.4024 94.6872 57.9214 94.9952 52.9637C95.9427 37.7151 90.0757 25.8044 81.9514 17.6799ZM77.7629 64.1379C77.7357 64.1959 77.7114 64.2499 77.6831 64.3097C76.9781 66.3272 75.7635 68.0142 74.5429 69.5069C69.7706 75.3409 62.4991 80.4039 52.5604 81.2376C44.4002 81.9216 37.1351 79.2231 32.0732 75.7434C27.6746 72.7196 24.3309 68.9766 21.9862 64.4782C21.8432 64.2076 20.4816 61.0704 20.4776 60.9324C18.6201 55.1709 18.4589 45.9066 20.3654 40.3471C21.6377 36.6366 23.7582 32.6219 26.5667 29.4412C30.4444 25.0494 34.3249 22.2352 40.4664 20.2461C43.2706 19.3377 45.7809 18.4132 49.2337 18.3216C57.6537 18.0974 66.2279 21.8779 70.8316 26.0197C75.0622 29.8259 79.8839 37.2401 81.0961 44.1961C82.3436 51.3556 81.0122 58.3457 77.7629 64.1379Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1281 71.0055C61.0548 71.0055 59.2353 69.6925 58.6003 67.7382L56.291 60.7018H44.7385L42.5928 67.674C41.9451 69.6663 40.1118 71 38.0278 71C37.5275 71 37.0305 70.9208 36.5506 70.7652C34.0596 70.0173 32.6455 67.3362 33.4086 64.7918L43.1596 33.9047C43.7928 31.9398 45.6568 30.5693 47.693 30.5693H52.878C54.9256 30.5693 56.7895 31.9165 57.4103 33.8455L67.6651 64.7212C68.4851 67.2455 67.1273 69.9553 64.64 70.765C64.1481 70.9247 63.6396 71.0055 63.1281 71.0055Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.128 70.3388C61.2706 70.3388 59.6436 69.1647 59.0757 67.417L56.7659 60.3792L56.653 60.0352H56.2908H44.7383H44.3691L44.2604 60.3881L42.1148 67.3602C41.5367 69.1384 39.8958 70.3333 38.0277 70.3333C37.5802 70.3333 37.1353 70.2625 36.7048 70.1229C34.4681 69.4513 33.2035 67.049 33.8874 64.7688L43.6363 33.8885C44.2021 32.1326 45.8742 30.9026 47.6928 30.9026H52.8778C54.7092 30.9026 56.3801 32.1105 56.9342 33.832L67.1905 64.7121C67.9244 66.9716 66.7091 69.3989 64.4851 70.1229C64.0435 70.2662 63.5871 70.3388 63.128 70.3388ZM63.128 71.3388C63.6922 71.3388 64.2528 71.2497 64.7942 71.0739C67.5465 70.178 69.0451 67.1848 68.1405 64.4L57.8847 33.5212C57.1985 31.3892 55.1419 29.9026 52.8778 29.9026H47.6928C45.4382 29.9026 43.3829 31.4145 42.6836 33.5846L32.9317 64.4746C32.0882 67.2867 33.6477 70.2491 36.4067 71.0774C36.9261 71.246 37.4752 71.3333 38.0277 71.3333C40.3295 71.3333 42.3539 69.859 43.0682 67.6619L45.2162 60.6822L44.7383 61.0352H56.2908L55.8158 60.6911L58.1251 67.7274C58.8268 69.887 60.8387 71.3388 63.128 71.3388Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8334 20.7257L24.8212 20.7092C23.6052 19.0427 23.9621 16.7113 25.7529 15.4043C27.5437 14.0975 29.8442 14.4643 31.0602 16.1307L31.0724 16.1472C32.2884 17.8137 31.9316 20.1452 30.1407 21.452C28.3499 22.7588 26.0494 22.3922 24.8334 20.7257ZM29.4429 17.3618L29.4307 17.3453C28.8197 16.508 27.6821 16.22 26.7951 16.8673C25.9162 17.5087 25.8479 18.6512 26.4589 19.4887L26.4711 19.5052C27.0822 20.3425 28.2197 20.6305 29.0986 19.9892C29.9857 19.3418 30.0541 18.1993 29.4429 17.3618Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5571 9.80283L38.3846 9.21649L43.5078 15.1722L41.475 15.8243L40.5846 14.7627L37.9458 15.6093L37.8491 16.9878L35.8555 17.6275L36.5571 9.80283ZM39.5638 13.4625L38.1775 11.7622L38.0293 13.9548L39.5638 13.4625Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7989 11.5945L46.8149 7.56067L48.8369 7.56867L48.821 11.5615C48.8169 12.5982 49.3384 13.0928 50.139 13.0962C50.9397 13.0993 51.465 12.6293 51.4689 11.6235L51.485 7.5795L53.507 7.5875L53.4912 11.57C53.482 13.8897 52.154 14.9007 50.1114 14.8925C48.0689 14.8842 46.79 13.8423 46.7989 11.5945Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8099 10.8897L58.7485 10.2605L59.2579 8.59167L65.285 10.4312L64.7757 12.1L62.7144 11.471L61.1265 16.6737L59.2222 16.0925L60.8099 10.8897Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6685 12.7598L72.3262 13.863L70.8365 16.1017L72.9642 17.5177L74.454 15.2788L76.1117 16.382L72.1312 22.3635L70.4733 21.2603L71.986 18.9873L69.8582 17.5713L68.3457 19.8443L66.688 18.7412L70.6685 12.7598Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5246 78.1472L76.5372 78.1633C77.8162 79.7822 77.5486 82.1258 75.8089 83.5002C74.0692 84.8745 71.7562 84.5958 70.4772 82.977L70.4646 82.9608C69.1856 81.3418 69.4534 78.9983 71.1929 77.624C72.9326 76.2498 75.2456 76.5283 76.5246 78.1472ZM72.0464 81.685L72.0591 81.7012C72.7017 82.5147 73.8496 82.759 74.7114 82.0782C75.5651 81.4037 75.5899 80.2593 74.9471 79.4458L74.9344 79.4297C74.2919 78.6162 73.1439 78.3718 72.2902 79.0463C71.4284 79.7272 71.4037 80.8715 72.0464 81.685Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2843 89.5303L63.4843 90.1965L58.104 84.4722L60.1062 83.731L61.0425 84.7527L63.6415 83.7907L63.6773 82.4093L65.641 81.6825L65.2843 89.5303ZM62.1195 86.0067L63.5793 87.6442L63.6308 85.4472L62.1195 86.0067Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9812 88.1641L55.159 92.1939L53.139 92.2831L52.9629 88.2943C52.9172 87.2586 52.3725 86.7896 51.5727 86.8249C50.7729 86.8603 50.2707 87.3551 50.315 88.3599L50.4934 92.3999L48.4734 92.4891L48.2977 88.5106C48.1954 86.1933 49.4734 85.1196 51.5139 85.0296C53.5545 84.9394 54.882 85.9184 54.9812 88.1641Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9452 89.4819L43.0263 90.0437L42.5715 91.7284L36.4863 90.0859L36.9412 88.401L39.0223 88.9629L40.4402 83.7102L42.3628 84.2292L40.9452 89.4819Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1083 88.018L29.4002 86.9943L30.7827 84.6875L28.5905 83.3735L27.208 85.6803L25.5 84.6566L29.194 78.4935L30.902 79.5173L29.4983 81.8593L31.6907 83.1733L33.0943 80.8313L34.8023 81.8551L31.1083 88.018Z",
    fill: "#BFE5F4",
    fillOpacity: 0.407843
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOauth);
export default __webpack_public_path__ + "static/media/oauth.05c7c998a0c6a7631f1d28823fa53538.svg";
export { ForwardRef as ReactComponent };